
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq9Vz8UNKWvaLZdCWwUIaRh21PR0EhHfsrcQwA20jEm8IMeta } from "/codebuild/output/src403724687/src/src/pages/faq.vue?macro=true";
import { default as menuUNcpAF6O2TqgDfKzmn8LNJ32wU6nlqgZfCyeddoVtBAMeta } from "/codebuild/output/src403724687/src/src/pages/menu.vue?macro=true";
import { default as indexicSjndJkmd_45MoKeipbZnUDAKxodWr_W1HXgexvGSC58Meta } from "/codebuild/output/src403724687/src/src/pages/index.vue?macro=true";
import { default as contactyB4T5bUX_fWwZn92VLY4ZfDQA5GdAnNbWMl10_458smH4Meta } from "/codebuild/output/src403724687/src/src/pages/contact.vue?macro=true";
import { default as tutorialYAYMm8dvrBJ3dp6VlLmIJRr5i1KhRRlmy7ZwGB8XgMgMeta } from "/codebuild/output/src403724687/src/src/pages/tutorial.vue?macro=true";
import { default as agreementswb8o0P_hFzrdIAShB2M5CkM5OexcPMVLRPhICOhhMkMeta } from "/codebuild/output/src403724687/src/src/pages/agreement.vue?macro=true";
import { default as about_45passozWw8vm2uiRBN804MZnEx4HGWnVY3yeFXmv75teT0tgMeta } from "/codebuild/output/src403724687/src/src/pages/about-pass.vue?macro=true";
import { default as indexr5AJaXK9_b1yZbL21gRV7UNNzNikY5uyiinTogUBFJUMeta } from "/codebuild/output/src403724687/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93dKiH1QYjOXQPHLr9nTwafRKQ56noLMF4Tc8IHUlUgQcMeta } from "/codebuild/output/src403724687/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance7L22BUKCLdigYiD0S0gcD0NdMGh7e8dR_45X1JDJPwEM8Meta } from "/codebuild/output/src403724687/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93b8MTMUfp7C_457qbtHoTC189n5A6S5lSPGMAfFdJKEwmQMeta } from "/codebuild/output/src403724687/src/src/pages/notice/[id].vue?macro=true";
import { default as indexIoHQRUNgt6o_p05VzEQWRYoud7UbAVxYaUCZImQKDF8Meta } from "/codebuild/output/src403724687/src/src/pages/coupon/index.vue?macro=true";
import { default as indexIBAUH_458ogwBlnYudPvZ7ibQbI9FdAyLQqglVwKDLPIUMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/index.vue?macro=true";
import { default as indexCAYu8eJD4jQlDeJYDCHzArFYAoPenb3ga71xzmElID4Meta } from "/codebuild/output/src403724687/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93mFjmHdpsqGlZwPasXXYnqYRtSP4aZaHtieJy2ouCnQYMeta } from "/codebuild/output/src403724687/src/src/pages/parking/[id].vue?macro=true";
import { default as index5yYQ5LS_AJt2FAoESPQ3_V3xjW8ORNF_45z7w0uzGBjecMeta } from "/codebuild/output/src403724687/src/src/pages/history/index.vue?macro=true";
import { default as indexNV_NY1O4yCxLEA6UTZUbIRKHhFRfvd5D4j3ujJ4Jf0UMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/index.vue?macro=true";
import { default as indexafzJIwwSSGM8qRFKGMyzwg97t6AGcmmuD9NCBcerV3IMeta } from "/codebuild/output/src403724687/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexrbyRKjz_45dXMve5wyAx0sp6pkJoRkqhRylpNnGgvqqY4Meta } from "/codebuild/output/src403724687/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviIavdGT1IvIG5dzwA34h9eq10GaB0cDbI5g6gGFzBJfwMeta } from "/codebuild/output/src403724687/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit_Pj0bzimasFG7lxOhRq6kcjaFKVURetHG8LiR6NmqEYMeta } from "/codebuild/output/src403724687/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementM8jMXa9YPaePYHVApwJ3zHPXNo03rpIwDwx3Zk_4vh8Meta } from "/codebuild/output/src403724687/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexo0f4rfoCUoaldGVrKA8_45bZ467Z8Wzgp6UCJLwZwlrhIMeta } from "/codebuild/output/src403724687/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dn79bEXaDbH8oC500wfGnyuZa_awceowq6EDP_HxWEdoMeta } from "/codebuild/output/src403724687/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmB6fhzX0HU2UiBZy3x6TVS_45oUV97UtBZ1J2WqbbZYVH8Meta } from "/codebuild/output/src403724687/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as index0Tvt2YplGoD_454bZGj8TBEcZsWvuQ0fq65JRucEAYMoEMeta } from "/codebuild/output/src403724687/src/src/pages/card/create/index.vue?macro=true";
import { default as index47UGczb_FlQvL7tbV_do78FkmpyhvDJx_45t4KAOtuAJAMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmykUXEx7cpZN94wWGErTES6E8EUCbzYQA7M7YXXa7m_45cMeta } from "/codebuild/output/src403724687/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirm2_vM9JC8AcEX2enud0uZttdgK2r5Oe_x6tos0C_45xXwUMeta } from "/codebuild/output/src403724687/src/src/pages/card/create/confirm.vue?macro=true";
import { default as complete_45KGeL7ZOYE4t6oZ3K5tXwbUPYHl6f5Nlyw0IzMzV4AwMeta } from "/codebuild/output/src403724687/src/src/pages/membership/complete.vue?macro=true";
import { default as registerehuxIa1x6vEPwBmsdQaaIEtsAxOfyaemgdZNsAET4E8Meta } from "/codebuild/output/src403724687/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93vlOGClNd2eJmWMZu4yt4tAq7PgnEwnc0Xf6Jpue1zCoMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmkmepdvVMXmO_457gLb4u64rpo5_45i_45tl97aQ2AEEKBBAO0Meta } from "/codebuild/output/src403724687/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93bmjT137s6kIYSPg7QcFJvaDu7tc1CeX65f1mya_45YRywMeta } from "/codebuild/output/src403724687/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as index2Jb_457L5SptyqofJqM4uVv5vK4TfPT1vNeOnclpYXjxkMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codevSfFrtiNSUBr0CPSfk_ry_45Zkoag6_45evn8SZ9g2heIPkMeta } from "/codebuild/output/src403724687/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codedBptBc5Koi0zNsuogWz9M18DoZSsnCG_45ahGP_K52WQwMeta } from "/codebuild/output/src403724687/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeH3fUqXMZLpsckEMvVlifLJw3uZpGTtIz1m_F497wkQIMeta } from "/codebuild/output/src403724687/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerKRQZNQap9yILVOCF9Vg2xzohwFi9DaF2Ux068gJt9ZoMeta } from "/codebuild/output/src403724687/src/src/pages/contact-form/register.vue?macro=true";
import { default as complete1aztK2q8XOg34TW1fGMxzrQi_45Yg7RRoSrkAhXpKQlxEMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index9pfKAwEe8yBnGTu0gpLvAb35uTwWK2sU8_45KgQoJriq0Meta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm9KcO35eF3K7I1oUGjp8PAK407xSHdmQECKCfcdiabkIMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completetPnvA0grdInyQMUPuYzPtp8sRFCSSzVazMnqXOdrGH0Meta } from "/codebuild/output/src403724687/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexdZbfzjtV5RsxjqcOZN4B2wEFavUOPXbb_45MUj7RF57_cMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93fCMwf0xiLKXkURct3ew4eG6oR3UO9DQ5GufqvnvpHiAMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as completeeteQfK54dQmlSgjyJQXjA4pj4JM9BUwL93UZ6X5eRccMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasPmVwwPhzaURePoaKBaPdemen_NkYF4PUtcYfVa_FQCQMeta } from "/codebuild/output/src403724687/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplez0LZdaEZQQBxJz2z9w14x9Qg2t6QNA6QbCZM1cA1MT0Meta } from "/codebuild/output/src403724687/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45email1sOoHkrSGW6VLqh210L7DkcQgm2PfQLQ4SzghiBSa_45YMeta } from "/codebuild/output/src403724687/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmrlLjdyIunradfFcD47ED2JDi9FZx0I1My4_45xb4v95G0Meta } from "/codebuild/output/src403724687/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentq4wEJ_45ri3tCPknsNcD7gLiIQtefd7_45vY_gIXMGwi_IIMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmyiVTo87HiKYvQ2PciC72jY8rb7hzK3g5EohsEjYawxQMeta } from "/codebuild/output/src403724687/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate8G_45_45etTDcmAeaP_45_b_45DT1Qse9oJ22viBeYCUcfYeuxoMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completei25XzNuS0Qowet5P4BNVZoouw_Xha8ZsdENERYn8i1MMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeF7mzstr54SH_45i60Urt2KW24Wt4uX9RsA5m2u6BAFf3UMeta } from "/codebuild/output/src403724687/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordhYSZ_7qUf5jGy9g3Zd2gNdTv02SwWXpmpnt3n57urSsMeta } from "/codebuild/output/src403724687/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasRuwqXV21ktU9DcAF7S3Sn6uWmdq19qRE80T3NM9jC_YMeta } from "/codebuild/output/src403724687/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register3fS9KDwOCZrzsDrzN1yLBalDZxLoh7qAZt9DE_KMze0Meta } from "/codebuild/output/src403724687/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeCNFfYNP1RRKsQSlEIfOEnS4lLXDgXKf0gSByqS7v7kIMeta } from "/codebuild/output/src403724687/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexshNw6uSPwuTe8llTI4smObSLe3JN_DUuecPrZMiLg98Meta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexVeKUfS4m2_mfCfbDijeT9cgG3q5KDfVe9Ww8JDy1idsMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexxNIjccUwyO2NAAMYnSCFXY2YQbLwSIYrsfh18afW7X0Meta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexdkljGtZRf3YKnxKNQ2aUlSJfr8a_HGE3f4TqAesIgMcMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateLFyx4nI80KF4zEhgyzRhh0DgCnZuHL63zSES_t_45fnjIMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeqAwVS7DPS7t6KZoIDjDOe1VPCRuVKNZBnQVioEs9B6IMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmQbsYdcvOiBiEmoz7oUvBMZLVE2ZHCh7cEbgyhg6X_45YAMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexYzTzZMxN7VW0265BW0VUCtKsiF2N7nQhPCdYi5PlBucMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeoba0lGOipmrMn2JUEAGgqCHVMePh9LMNuWaqbtmCbw8Meta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateFvL0jYZR_n3Uwu9IPUG_45XANFBzwSycswieK7JiKPIdgMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index2zTzOBpFnGTlHU1Dyu_45lpv0dLfKSZQB6uAoIydt8E2IMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indextKvnukdnN745gppO1MAOE0rM759MzahBHDG2tgPrBSkMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completer5ohwzklO3MLYxxpYUpDzERNcI_q5e57eCBzVb1_45v3IMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexvxW29_45msAKKVKV05eKiJ7cTAadxqztfZnvlCyX3UNhkMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeqpo5mInMzKg1PLa_4564eysJ6zMHx_45kc_45uCBljQeENidQMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexXqvY2_CHMPrhw_45gooTsxz4A9tqsCoJ5KSAO83pa68A0Meta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexNFad5cSb4Z0pdnOiXWg73BTaU1YkLhn7FTTH71eb2AwMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexw7lqc1hsQBHDCVc00sA_J20v08UZNwAk4vAFGpZCbEkMeta } from "/codebuild/output/src403724687/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateNbrhlCD4WCFt4I9EEqcnad8E6CyNwkXYBsFBFrLK_45AgMeta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirm5ZSD_fB8ycH_45Pn9XLGf199q6XWcnlURophqsoo_VL28Meta } from "/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src403724687/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuUNcpAF6O2TqgDfKzmn8LNJ32wU6nlqgZfCyeddoVtBAMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexicSjndJkmd_45MoKeipbZnUDAKxodWr_W1HXgexvGSC58Meta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src403724687/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src403724687/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src403724687/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src403724687/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src403724687/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexIoHQRUNgt6o_p05VzEQWRYoud7UbAVxYaUCZImQKDF8Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src403724687/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src403724687/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index5yYQ5LS_AJt2FAoESPQ3_V3xjW8ORNF_45z7w0uzGBjecMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexafzJIwwSSGM8qRFKGMyzwg97t6AGcmmuD9NCBcerV3IMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexrbyRKjz_45dXMve5wyAx0sp6pkJoRkqhRylpNnGgvqqY4Meta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src403724687/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src403724687/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: index0Tvt2YplGoD_454bZGj8TBEcZsWvuQ0fq65JRucEAYMoEMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmykUXEx7cpZN94wWGErTES6E8EUCbzYQA7M7YXXa7m_45cMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirm2_vM9JC8AcEX2enud0uZttdgK2r5Oe_x6tos0C_45xXwUMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: complete_45KGeL7ZOYE4t6oZ3K5tXwbUPYHl6f5Nlyw0IzMzV4AwMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerehuxIa1x6vEPwBmsdQaaIEtsAxOfyaemgdZNsAET4E8Meta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmkmepdvVMXmO_457gLb4u64rpo5_45i_45tl97aQ2AEEKBBAO0Meta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codevSfFrtiNSUBr0CPSfk_ry_45Zkoag6_45evn8SZ9g2heIPkMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codedBptBc5Koi0zNsuogWz9M18DoZSsnCG_45ahGP_K52WQwMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeH3fUqXMZLpsckEMvVlifLJw3uZpGTtIz1m_F497wkQIMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerKRQZNQap9yILVOCF9Vg2xzohwFi9DaF2Ux068gJt9ZoMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm9KcO35eF3K7I1oUGjp8PAK407xSHdmQECKCfcdiabkIMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completetPnvA0grdInyQMUPuYzPtp8sRFCSSzVazMnqXOdrGH0Meta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexdZbfzjtV5RsxjqcOZN4B2wEFavUOPXbb_45MUj7RF57_cMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: completeeteQfK54dQmlSgjyJQXjA4pj4JM9BUwL93UZ6X5eRccMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplez0LZdaEZQQBxJz2z9w14x9Qg2t6QNA6QbCZM1cA1MT0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45email1sOoHkrSGW6VLqh210L7DkcQgm2PfQLQ4SzghiBSa_45YMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmrlLjdyIunradfFcD47ED2JDi9FZx0I1My4_45xb4v95G0Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentq4wEJ_45ri3tCPknsNcD7gLiIQtefd7_45vY_gIXMGwi_IIMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmyiVTo87HiKYvQ2PciC72jY8rb7hzK3g5EohsEjYawxQMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completei25XzNuS0Qowet5P4BNVZoouw_Xha8ZsdENERYn8i1MMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeF7mzstr54SH_45i60Urt2KW24Wt4uX9RsA5m2u6BAFf3UMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordhYSZ_7qUf5jGy9g3Zd2gNdTv02SwWXpmpnt3n57urSsMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src403724687/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register3fS9KDwOCZrzsDrzN1yLBalDZxLoh7qAZt9DE_KMze0Meta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeCNFfYNP1RRKsQSlEIfOEnS4lLXDgXKf0gSByqS7v7kIMeta || {},
    component: () => import("/codebuild/output/src403724687/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src403724687/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src403724687/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]